import { Dialog } from 'app/agriculture/components/Dialog/Dialog';
import { AgricultureFarmSelector } from 'app/agriculture/FarmMain/TopBar/components/agriculture_farm_selector/agriculture_farm_selector';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { useContext, useState } from 'react';
import { FarmContext } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';
import { useNavigate } from 'react-router-dom';
import { ServicesContext } from 'app/items/shared/context_interface';

export function FarmSwitchDialog() {
    const { farm, setFarm } = useContext(FarmContext);
    const { selectionService } = useContext(ServicesContext);
    const navigate = useNavigate();
    const [farmId, setFarmId] = useState(farm.id);

    return (
        <Dialog
            disableCloseButton
            actions={{
                primaryAction: {
                    text: 'Confirm',
                    onClick: () => {
                        // This is a temporary hack to stop the map showing everything in deselected
                        // mode when you switch farms with something selected.
                        selectionService.clearSelection();
                        setFarm(farmId);
                        navigate(`/${farmId}`);
                    },
                },
            }}
        >
            <SimpleGrid>
                <h3>Select a farm</h3>
                <AgricultureFarmSelector defaultValue={farmId} onChange={setFarmId} />
            </SimpleGrid>
        </Dialog>
    );
}
